import { Routes, Route, Navigate } from "react-router-dom";
import ClientLayout from "../Layout/ClientLayout";
import DashboardLayout from "../Layout/DashboardLayout";

// Client pages
import Home from "../Screens/User/Home";
import AboutUs from "../Screens/User/AboutUs";
import Courses from "../Screens/User/Courses";
import CourseDetail from "../Screens/User/CourseDetails";
import Articles from "../Screens/User/Articles";
import ArticleDetails from "../Screens/User/ArticleDetails";
import Careers from "../Screens/User/Career";
import Contact from "../Screens/User/Contact";

// Admin pages
import DashboardHome from "../Screens/Admin/DashboardHome";
import DashboardArticle from "../Screens/Admin/DashboardArticle";
import DashboardCareers from "../Screens/Admin/DashboardCareers";
import DashboardCourse from "../Screens/Admin/DashboardCourse";
import DashboardInquiry from "../Screens/Admin/DashboardInquiry";

import ProtectedRoute from "./ProtectedRoute";
import RoleGuard from "./RoleGuard";
import Login from "../Screens/Common/Login";
import TermsAndConditions from "../Screens/User/TermsAndConditions";
import PrivacyPolicy from "../Screens/User/PrivacyPolicy";

export default function AppRouter() {
  return (
    <Routes>
      {/* Client layout */}
      <Route element={<ClientLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/articles/:id" element={<ArticleDetails />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tc" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>

      {/* ✅ Login Page */}
      <Route path="/login" element={<Login />} />

      {/* Admin layout */}
      <Route
        element={<DashboardLayout />}
        // element={
        //   <ProtectedRoute>
        //     <RoleGuard allow={["admin"]}>
        //       <DashboardLayout />
        //     </RoleGuard>
        //   </ProtectedRoute>
        // }
      >
        <Route path="/admin" element={<DashboardHome />} />
        <Route path="/admin/home" element={<DashboardHome />} />
        <Route path="/admin/courses" element={<DashboardCourse />} />
        <Route path="/admin/articles" element={<DashboardArticle />} />
        <Route path="/admin/careers" element={<DashboardCareers />} />
        <Route path="/admin/inquiries" element={<DashboardInquiry />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
